import React from 'react';

const Flutter = () => {
    return (
        <>
            <div className="breadcrumb-area">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="breadcrumb_box text-center">
                                <h2 className="breadcrumb-title">Flutter: Google's UI Toolkit</h2>
                                <ul className="breadcrumb-list">
                                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                                    <li className="breadcrumb-item"><a href="/technologies">Technologies</a></li>
                                    <li className="breadcrumb-item active">Flutter</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="service-details-wrapper section-space--ptb_100">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8">
                            <div className="content-area">
                                <div className="service-details-content">
                                    <h1>Flutter: Build Beautiful Native Apps Fast</h1>
                                    
                                    <p className="lead">Flutter is Google's UI toolkit for building natively compiled applications for mobile, web, and desktop from a single codebase. It delivers beautiful, fast, and expressive apps. Used by Google, BMW, Alibaba, and Tencent.</p>

                                    <h3 className="mt-50">Exceptional Beauty & Performance</h3>
                                    <p>Flutter's widget system enables developers to create beautifully designed apps with pixel-perfect consistency across platforms. The Dart language and Flutter engine deliver native performance with minimal overhead.</p>

                                    <h3 className="mt-40">Core Features</h3>
                                    <ul>
                                        <li><strong>Hot Reload & Hot Restart:</strong> See changes instantly, dramatically accelerating development</li>
                                        <li><strong>Beautiful UI Components:</strong> Extensive widget library with Material and Cupertino designs</li>
                                        <li><strong>Excellent Performance:</strong> 60fps (120fps on capable devices) animations</li>
                                        <li><strong>Native Compilation:</strong> True native performance with Dart compilation</li>
                                        <li><strong>Strong Typing with Dart:</strong> Compile-time type safety</li>
                                        <li><strong>Cross-Platform Compatibility:</strong> iOS, Android, Web, Windows, macOS, Linux</li>
                                        <li><strong>Rich Package Ecosystem:</strong> Thousands of community packages</li>
                                        <li><strong>Professional Tooling:</strong> DevTools, Inspector, and debugger</li>
                                    </ul>

                                    <h3 className="mt-40">Real-World Applications</h3>
                                    <p><strong>Enterprise Apps:</strong> BMW uses Flutter for their dealer and customer apps.</p>
                                    <p><strong>E-Commerce:</strong> Alibaba built their app with Flutter for high-speed transactions.</p>
                                    <p><strong>Financial Services:</strong> Google Pay uses Flutter for seamless payment experience.</p>

                                    <h3 className="mt-40">AppCore's Flutter Expertise</h3>
                                    <div className="case-study-box mt-30">
                                        <h5>Success: Multi-Platform Enterprise App</h5>
                                        <p>We developed a comprehensive platform using Flutter:</p>
                                        <ul>
                                            <li>📱 iOS, Android, Web in single codebase</li>
                                            <li>⚡ 120fps animations on flagship devices</li>
                                            <li>🎨 Pixel-perfect UI across all platforms</li>
                                            <li>🚀 Launched all platforms simultaneously</li>
                                        </ul>
                                    </div>

                                    <h3 className="mt-40">Flutter Best Practices</h3>
                                    <ul>
                                        <li>Widget composition and reusability</li>
                                        <li>State management (Provider, Riverpod, BLoC)</li>
                                        <li>Performance optimization techniques</li>
                                        <li>Platform-specific integrations</li>
                                        <li>Testing strategies (unit, widget, integration)</li>
                                        <li>CI/CD for multi-platform delivery</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="sidebar-area">
                                <div className="sidebar-widget mb-50">
                                    <h5 className="widget-title mb-30">Flutter Advantages</h5>
                                    <ul className="sidebar-list">
                                        <li>🎨 Beautiful UI Design</li>
                                        <li>⚡ Outstanding Performance</li>
                                        <li>🔥 Hot Reload Magic</li>
                                        <li>📱 True Cross-Platform</li>
                                        <li>💻 Web & Desktop Support</li>
                                        <li>🚀 Fast Development</li>
                                    </ul>
                                </div>

                                <div className="sidebar-widget">
                                    <h5 className="widget-title mb-30">Implementation Stats</h5>
                                    <div className="metric-item mb-20">
                                        <p className="metric-label">Flutter Projects</p>
                                        <p className="metric-value" style={{color: '#64b1a6', fontSize: '24px', fontWeight: 'bold'}}>25+</p>
                                    </div>
                                    <div className="metric-item mb-20">
                                        <p className="metric-label">FPS Performance</p>
                                        <p className="metric-value" style={{color: '#64b1a6', fontSize: '24px', fontWeight: 'bold'}}>120 fps</p>
                                    </div>
                                    <div className="metric-item">
                                        <p className="metric-label">Dev Satisfaction</p>
                                        <p className="metric-value" style={{color: '#64b1a6', fontSize: '24px', fontWeight: 'bold'}}>4.9/5</p>
                                    </div>
                                </div>

                                <div className="sidebar-widget mt-50">
                                    <h5 className="widget-title mb-30">Fortune 500 Trust</h5>
                                    <p className="small">Google, BMW, Alibaba, Tencent, and eBay use Flutter for high-performance, beautiful mobile experiences.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Flutter;
